import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import DesignLink from '@components/DesignLink';

import {
	changeDateFormat,
	convertNumberToUSFormat,
	dateOrder,
	packTag,
	setTag,
	STATIC_SET_CONSTANTS
} from '@utils/Util';

export const BrandAndTeamCell = ({ item, rowSpan }) => {
	return (
		<td className="brand-and-team" rowSpan={rowSpan}>
			{item.brandName && <p className="semibold-12">{item.brandName}</p>}
			{item.accountManagerName && (
				<p className="regular-12 gray_dark_02">
					A/C: <span className="gray_dark_01">{item.accountManagerName}</span>
				</p>
			)}
			{item.projectManagerName && (
				<p className="regular-12 gray_dark_02">
					PM: <span className="gray_dark_01">{item.projectManagerName}</span>
				</p>
			)}
			{item?.merchandiserNameList?.length > 0 && (
				<p className="regular-12 gray_dark_02">
					MR: <span className="gray_dark_01">{item?.merchandiserNameList?.join(', ')}</span>
				</p>
			)}
			{item.buyerName && (
				<p className="regular-12 gray_dark_02">
					BYR: <span className="gray_dark_01">{item.buyerName}</span>
				</p>
			)}
		</td>
	);
};

export const StyleCell = ({ item, rowSpan, isProductOfSet, openDesignViewModal }) => {
	const navigate = useNavigate();

	return (
		<td className="style-column" rowSpan={rowSpan}>
			<div className="d-flex align-items-center">
				{isProductOfSet ? (
					<div
						className="style"
						onClick={() => {
							navigate(`/orders/view/${item.orderId}?rfqId=${item.id}`);
						}}
					>
						{item.productFeatureImageUrlList && (
							<div className="set-image-layout" style={{ width: '65px' }}>
								{item?.productFeatureImageUrlList.slice(0, 2).map((image, index) => (
									<img
										key={index}
										src={image}
										alt={`image ${index + 1}`}
										className="cell-img pr-2"
									/>
								))}
							</div>
						)}
					</div>
				) : (
					<div className="style">
						{item.productFeatureImageUrl && (
							<img
								src={item.productFeatureImageUrl}
								alt="order-style"
								className="style-image"
								onClick={() => {
									navigate(`/orders/view/${item.orderId}?rfqId=${item.id}`);
								}}
							/>
						)}
					</div>
				)}

				<div className="info">
					<div className="mb-1">
						{isProductOfSet && setTag()}{' '}
						{item?.setPackStyleFlag === STATIC_SET_CONSTANTS.PACK_PRODUCT && packTag()}
					</div>
					<DesignLink id={item?.productId} onClickDesignView={() => openDesignViewModal(item)}>
						<span className="regular-12 weight-500  gray_dark_01 link">
							{item.productReferenceNo}&nbsp;
						</span>
					</DesignLink>
					<p className="regular-12 gray_dark_02 mb-1 word-break">{item.poNumber}</p>
					<p className="regular-10 gray_dark_01 mb-0">
						{item.productGroupName}{' '}
						{(item.productGroupName && item.category) !== undefined ? ',' : ''}{' '}
						{item.setPackStyleFlag !== STATIC_SET_CONSTANTS.SET_PRODUCT && item.category}
					</p>
					{item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT &&
						item.setCategoryList &&
						item?.setCategoryList.map((ctg, index) => (
							<p className="regular-10 gray_dark_01" key={index}>
								{ctg}
								{index !== item?.setCategoryList.length - 1 && ', '}
							</p>
						))}
					<p className="regular-10 gray_dark_01">
						{item.noOfColor} Color, {item.noOfSize} sizes
					</p>
				</div>
			</div>{' '}
		</td>
	);
};

export const FabricCell = ({ rowSpan, item }) => {
	return (
		<td className="po-details" rowSpan={rowSpan}>
			{item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT ? (
				<ul className="with-bullet">
					{item.setFabricNameList &&
						item.setFabricNameList.length > 0 &&
						item?.setFabricNameList.map((fabricList, index) => (
							<li className="pb-2" key={`${fabricList}-${index}`}>
								{fabricList}
							</li>
						))}
				</ul>
			) : (
				<ul className="with-bullet">
					<li className="pb-2">{item.fabricName}</li>
				</ul>
			)}
		</td>
	);
};

export const PoCell = ({ rowSpan, item, streamList }) => {
	return (
		<td className="po-details" rowSpan={rowSpan}>
			<Link to={`/orders/view/${item.orderId}`} className="semibold-12 weight-500 link">
				{item.orderName}&nbsp;
				{item.orderRefNo && <span>({item.orderRefNo})</span>}
			</Link>
			<p className="regular-12 gray_dark_02">
				PO qty: <span className="gray_dark_01">{convertNumberToUSFormat(item.poQuantity)}</span>
			</p>
			<p className="regular-12 gray_dark_02">
				PO value:{' '}
				<span className="gray_dark_01">
					{item.poValue ? '$' : ''}
					{convertNumberToUSFormat(item.poValue)}
				</span>
			</p>
			<p className="regular-12 gray_dark_02">
				Margin:{' '}
				{item.salesContractAmount ? (
					<span className="gray_dark_01">
						{item.margin ? '$' : ''}
						{convertNumberToUSFormat(item.margin)} ({item.marginPercent?.toFixed(2)}%)
					</span>
				) : (
					'N/A'
				)}
			</p>
			<p className="regular-12 gray_dark_02">
				PO recived:{' '}
				<span className="gray_dark_01">
					{changeDateFormat(item.poReceivedDate, 'YYYY-MM-DD', 'DD MMM, YY')}
				</span>
			</p>
			<p className="regular-12 gray_dark_02">
				Revenue Stream:{' '}
				<span className="gray_dark_01">
					{streamList?.find((stream) => stream.value === item.stream)?.label}
				</span>
			</p>
		</td>
	);
};

export const ScCell = ({ rowSpan, item }) => {
	return (
		<td className="sc-details" rowSpan={rowSpan}>
			<p className="regular-12 gray_dark_01 weight-500 mb-2">{item.factoryName}</p>
			<p className="regular-12 gray_dark_01 mb-2">{item.salesContractRefNo}</p>
			<p className="regular-12 gray_dark_01 mb-2">
				{item.salesContractAmount ? '$' : ''}
				{convertNumberToUSFormat(item?.salesContractAmount)}
			</p>
			{item?.amendmentNo && <p className="regular-12 mb-0">AMD: {item?.amendmentNo}</p>}
		</td>
	);
};

export const ShipmentCell = ({ rowSpan, item }) => {
	return (
		<td rowSpan={rowSpan}>
			<p className="semibold-12 weight-500">{item.commercialInvoiceNo}</p>
			<p className="regular-12 gray_dark_02 mb-2">
				{item.commercialInvoiceDate
					? changeDateFormat(item.commercialInvoiceDate, 'YYYY-MM-DD', 'DD MMM, YY')
					: ''}
			</p>
			<p className="regular-12 gray_dark_02">
				Qty: <span className="gray_dark_01">{convertNumberToUSFormat(item.shippedQuantity)}</span>
			</p>
			<p className="regular-12 gray_dark_02">
				Value:{' '}
				<span className="gray_dark_01">
					{item.commercialInvoiceAmount ? '$' : ''}
					{convertNumberToUSFormat(item.commercialInvoiceAmount)}
				</span>
			</p>
		</td>
	);
};

export const BuyerEtdCell = ({ date, index, rowSpan }) => {
	return (
		<td key={`etd-${index}`} className="etd-column buyer-etd" rowSpan={rowSpan}>
			<ul className="etd-list">
				<li className="regular-12 gray_dark_02">
					<div className="d-flex">
						<span className="semibold-12 gray_dark_01">
							{index + 1}
							{dateOrder(index + 1)} ETD:
						</span>{' '}
						<span>{changeDateFormat(date, 'YYYY-MM-DD', 'DD MMM, YY')}</span>
					</div>
				</li>
			</ul>
		</td>
	);
};

export const FactoryEtdCell = ({ rowSpan, date }) => {
	return (
		<td className="etd-column factory-etd" rowSpan={rowSpan}>
			<p className="regular-12 gray_dark_02">F: {changeDateFormat(date, 'YYYY-MM-DD', 'DD MMM, YY')}</p>
		</td>
	);
};

export const TnaStatusCell = ({ onClick, item, showTaskCounts, rowSpan }) => {
	return (
		<td className="tna-status cursor-pointer" onClick={onClick} rowSpan={rowSpan}>
			{item.tnaStatus && (item.tnaStatus === 'SAFE' || item.tnaStatus === 'SHIPPED') ? (
				<span className={`status ${item.tnaStatus?.toLowerCase().replace('_', '-')}`}>
					{item.tnaStatus?.replace('_', ' ')}
				</span>
			) : (
				showTaskCounts(item)
			)}
		</td>
	);
};

export const ExFactoryCell = ({ rowSpan, item }) => {
	return (
		<td className="etd-column factory-etd" rowSpan={rowSpan}>
			<p className="regular-12 gray_dark_02">
				{' '}
				Date: {changeDateFormat(item.exFactoryDate, 'YYYY-MM-DD', 'DD MMM, YY')}
			</p>
			<p className="regular-12 gray_dark_02"> Qty: {item.exFactoryQuantity}</p>
		</td>
	);
};
